import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Boxes } from "lucide-react";
import { findProduct } from "@/data/mellow";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EDITABLE = ["sweet-reminder-lemon", "green-days-carnet"];

export const StockPanel = ({ secret }) => {
  const [levels, setLevels] = useState(null);
  const [draft, setDraft] = useState({});

  useEffect(() => { fetch(`${API}/stock`).then((r) => r.json()).then(setLevels).catch(() => {}); }, []);

  const save = async (key) => {
    const res = await fetch(`${API}/admin/stock/${key}`, { method: "POST", headers: { "Content-Type": "application/json", "X-Admin-Secret": secret }, body: JSON.stringify({ quantity: Number(draft[key]) }) });
    if (!res.ok) return toast.error("Mise à jour impossible");
    setLevels(await res.json()); setDraft((d) => ({ ...d, [key]: undefined }));
    toast.success("Stock mis à jour ✿");
  };

  if (!levels) return null;
  return (
    <div className="rounded-3xl border-2 border-dashed border-[#D1D5CB] bg-[#EEF1E4] p-5 mb-8" data-testid="stock-panel">
      <p className="inline-flex items-center gap-2 font-cursive text-3xl text-[#78353A] leading-none"><Boxes className="w-5 h-5" /> Stock</p>
      <p className="text-xs text-[#4A3B32]/70 mt-1">Décompté automatiquement à chaque commande payée (un lot = 1 carnet + 1 pense-bête).</p>
      <div className="mt-4 grid sm:grid-cols-2 gap-3">
        {EDITABLE.map((key) => (
          <div key={key} className="flex items-center gap-3 rounded-2xl bg-[#FAF9F6] px-4 py-3" data-testid={`stock-row-${key}`}>
            <span className="flex-1 text-sm text-[#4A3B32]">{findProduct(key)?.name || key}</span>
            <input type="number" min={0} value={draft[key] ?? levels[key]} onChange={(e) => setDraft((d) => ({ ...d, [key]: e.target.value }))} data-testid={`stock-input-${key}`}
              className="w-20 rounded-full border-2 border-dashed border-[#D1D5CB] bg-[#FFFDF9] px-3 py-1.5 text-center font-cursive text-xl text-[#78353A]" />
            {draft[key] !== undefined && String(draft[key]) !== String(levels[key]) && (
              <button type="button" onClick={() => save(key)} data-testid={`stock-save-${key}`} className="rounded-full bg-[#FFF2B2] px-3 py-1.5 font-cursive text-lg text-[#4A3B32]">OK</button>
            )}
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs text-[#4A3B32]/70">Lots découverte possibles : <span className="font-semibold" data-testid="stock-lot">{levels["lot-decouverte"]}</span></p>
    </div>
  );
};
